export default function PricingStep({ formData, setFormData }) {

  const handleChange = (e) => {
    const value = e.target.value;

    setFormData(prev => ({
      ...prev,
      cheapestPrice: value
    }));
  };

  return (
    <div className="space-y-8">

      {/* TITLE */}
      <div>
        <h2 className="text-2xl font-semibold">
          Prix
        </h2>
        <p className="text-gray-500 mt-1">
          Définissez le prix minimum d’une chambre
        </p>
      </div>

      {/* CARD */}
      <div className="bg-gray-50 rounded-2xl p-6 space-y-6">

        {/* LABEL */}
        <div>
          <label className="block mb-2 text-sm font-medium">
            Prix minimum par nuit
          </label>

          {/* INPUT */}
          <div className="flex items-center border border-gray-300 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-green-500">

            <input
              type="number"
              placeholder="Ex: 50"
              value={formData.cheapestPrice}
              onChange={handleChange}
              className="w-full px-4 py-3 outline-none bg-transparent"
            />

            <div className="px-4 text-gray-500 bg-gray-100 h-full flex items-center">
              €
            </div>

          </div>
        </div>

        {/* INFO BOX */}
        <div className="bg-white border border-gray-200 rounded-xl p-4 text-sm text-gray-600">
          💡 Ce prix correspond à la chambre la moins chère disponible dans votre établissement.
          Vous pourrez modifier les tarifs plus précisément dans le calendrier.
        </div>

      </div>

      {/* PREVIEW */}
      {formData.cheapestPrice > 0 && (
        <div className="text-sm text-gray-500">
          Prix affiché aux clients :{" "}
          <span className="font-semibold text-black">
            {Number(formData.cheapestPrice).toLocaleString()} € / nuit
          </span>
        </div>
      )}

    </div>
  );
}